import React, { useContext, useEffect } from 'react';
import { Col } from 'reactstrap';
import { WeverCoreContext, _translate } from "../../../../../services/core";
var Sequences = function Sequences(_ref) {
  var elements = _ref.elements,
    index = _ref.index;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var currentQuestion = elements.currentQuestion,
    responses = elements.responses;
  var getName = function getName(response) {
    var name = '';
    currentQuestion.expectedResponses.forEach(function (expResp) {
      if (response === expResp.alias || response === expResp.value) {
        name = expResp.name[locale];
      }
    });
    return name;
  };
  useEffect(function () {}, [currentQuestion]);
  if (!currentQuestion) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Col, {
    className: "col-sm-12 col-md-12 col-lg-6 text-center px-2 sequence-information-element"
  }, /*#__PURE__*/React.createElement("h5", null, _translate('collectorapp_sequence'), " ", index + 1), responses && Object.keys(responses).map(function (alias) {
    var name = getName(responses[alias]);
    return /*#__PURE__*/React.createElement("div", {
      className: "element d-flex justify-content-center align-items-center mx-2 px-2"
    }, name);
  }));
};
export default Sequences;